import { TimeZoneService } from './../../modules/shared/services/timezone.service';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

// Pipes
import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';

// Constants
import {
    EMAIL_TYPE_IDS as EmailTypes, PHONE_TYPE_IDS as PhoneTypes, SOCIAL_PROFILE_TYPE_IDS as SocialProfileTypes,
    CUSTOMFIELD_TYPE_IDS as CustomFieldTypes
} from 'src/app/modules/shared/constants/typeId';

@Injectable({
    providedIn: 'root'
})

export class LeadHelper {
    baseLeadURL: string;

    constructor(
        public datePipe: DatePipe,
        private timeZoneService: TimeZoneService
    ) {
    }

    getContactDetails(leadData) {
        return leadData?.leadContacts?.find(contactData => contactData?.contact?.isPrimaryContact)?.contact;
    }

    getContactEmails(contactData) {
        let workEmailAddress, homeEmailAddress, ce1EmailAddress, ce2EmailAddress;

        contactData?.contactEmails?.forEach(emailData => {
            const { emailAddress, emailTypeId } = emailData?.email;

            switch (emailTypeId) {
                case EmailTypes.WORK: {
                    workEmailAddress = workEmailAddress ? workEmailAddress : emailAddress;
                    break;
                }
                case EmailTypes.HOME: {
                    homeEmailAddress = homeEmailAddress ? homeEmailAddress : emailAddress;
                    break;
                }
                case EmailTypes.CE1: {
                    ce1EmailAddress = ce1EmailAddress ? ce1EmailAddress : emailAddress;
                    break;
                }
                case EmailTypes.CE2: {
                    ce2EmailAddress = ce2EmailAddress ? ce2EmailAddress : emailAddress;
                    break;
                }
            }
        });

        return { workEmailAddress, homeEmailAddress, ce1EmailAddress, ce2EmailAddress };
    }

    getContactPhones(contactData) {
        let mobilePhone: any = {}, homePhone: any = {}, workPhone: any = {}, cp1Phone: any = {}, cp2Phone: any = {};

        contactData?.contactPhones?.forEach(phoneData => {
            const { number, phoneTypeId, code } = phoneData?.phone;

            switch (phoneTypeId) {
                case PhoneTypes.MOBILE: {
                    mobilePhone = mobilePhone?.number ? mobilePhone : { number, countryCode: code };
                    break;
                }
                case PhoneTypes.HOME: {
                    homePhone = homePhone?.number ? homePhone : { number, countryCode: code };
                    break;
                }
                case PhoneTypes.WORK: {
                    workPhone = workPhone?.number ? workPhone : { number, countryCode: code };
                    break;
                }
                case PhoneTypes.CP1: {
                    cp1Phone = cp1Phone?.number ? cp1Phone : { number, countryCode: code };
                    break;
                }
                case PhoneTypes.CP2: {
                    cp2Phone = cp2Phone?.number ? cp2Phone : { number, countryCode: code };
                    break;
                }
            }
        });

        return { mobilePhone, homePhone, workPhone, cp1Phone, cp2Phone };
    }

    getContactSocialProfiles(contactData) {
        let contactWebsite, contactTwitter, contactFacebook, contactLinkedin, contactInstagram;

        contactData?.contactSocialProfiles?.forEach(socialData => {
            const { name, socialProfileTypeId } = socialData?.socialProfile;

            switch (socialProfileTypeId) {
                case SocialProfileTypes.WEBSITE: {
                    contactWebsite = name;
                    break;
                }
                case SocialProfileTypes.FACEBOOK: {
                    contactFacebook = name;
                    break;
                }
                case SocialProfileTypes.TWITTER: {
                    contactTwitter = name;
                    break;
                }
                case SocialProfileTypes.LINKEDIN: {
                    contactLinkedin = name;
                    break;
                }
                case SocialProfileTypes.INSTAGRAM: {
                    contactInstagram = name;
                    break;
                }
            }
        });

        return { contactWebsite, contactTwitter, contactFacebook, contactLinkedin, contactInstagram };
    }

    getContactProfileImages(contactData) {
        let profileImages = contactData?.contactProfileImages?.filter(el => el.attachment);

        profileImages = profileImages?.map(el => {
            const { attachment: { name, downloadLink, sizeInBytes } } = el;
            return {
                name,
                downloadLink,
                sizeInKb: (sizeInBytes / 1024).toFixed(2)
            }
        }) || [];

        return profileImages;
    }

    getBusinessCaardImages(contactData) {
        let cardImages = contactData?.contactBusinessCards?.filter(el => el.attachment);

        cardImages = cardImages?.map(el => {
            const { attachment: { name, downloadLink, sizeInBytes } } = el;
            return {
                name,
                downloadLink,
                sizeInKb: (sizeInBytes / 1024).toFixed(2)
            }
        }) || [];

        return cardImages;
    }

    getLeadSocialProfiles(leadData) {
        let { leadSocials } = leadData;
        let leadWebsite, leadTwitter, leadFacebook, leadLinkedin, leadInstagram;

        leadSocials = leadSocials?.map(social => social?.socialProfile);

        leadSocials?.forEach(profile => {
            if (profile) {
                const { name, socialProfileTypeId } = profile;

                switch (socialProfileTypeId) {
                    case SocialProfileTypes.WEBSITE: {
                        leadWebsite = name;
                        break;
                    };
                    case SocialProfileTypes.TWITTER: {
                        leadTwitter = name;
                        break;
                    };
                    case SocialProfileTypes.FACEBOOK: {
                        leadFacebook = name;
                        break;
                    };
                    case SocialProfileTypes.LINKEDIN: {
                        leadLinkedin = name;
                        break;
                    };
                    case SocialProfileTypes.INSTAGRAM: {
                        leadInstagram = name;
                        break;
                    };
                }
            };
        });

        return { leadWebsite, leadTwitter, leadFacebook, leadLinkedin, leadInstagram };
    }

    removeCommas(data, key: string): string {
        let keyData: string = data[key];

        if (keyData) {
            keyData = keyData?.trim();
            keyData = keyData?.endsWith(',') ? keyData?.substring(0, keyData.length - 1) : keyData;
        }

        return keyData;
    }

    processLeadDetailsData(leadData) {
        const contactData = this.getContactDetails(leadData);
        const { workEmailAddress, homeEmailAddress, ce1EmailAddress, ce2EmailAddress } = this.getContactEmails(contactData);
        leadData.contactSequenceNumber = contactData?.sequenceNumber;
        leadData.contactemailwork = workEmailAddress;
        leadData.contactemailhome = homeEmailAddress;
        leadData.contactemailce1 = ce1EmailAddress;
        leadData.contactemailce2 = ce2EmailAddress;

        const { mobilePhone, homePhone, workPhone, cp1Phone, cp2Phone } = this.getContactPhones(contactData);

        leadData.contactphonemobile = mobilePhone?.number;
        leadData.contactphonehome = homePhone?.number;
        leadData.contactphonework = workPhone?.number;
        leadData.contactphonecp1 = cp1Phone?.number;
        leadData.contactphonecp2 = cp2Phone?.number;

        leadData.contactphonemobileCode = mobilePhone?.countryCode;
        leadData.contactphonehomeCode = homePhone?.countryCode;
        leadData.contactphoneworkCode = workPhone?.countryCode;
        leadData.contactphonecp1Code = cp1Phone?.countryCode;
        leadData.contactphonecp2Code = cp2Phone?.countryCode;

        const { contactWebsite, contactTwitter, contactFacebook, contactLinkedin, contactInstagram } =
            this.getContactSocialProfiles(contactData);

        leadData.contactsocialwebsite = contactWebsite;
        leadData.contactsocialtwitter = contactTwitter;
        leadData.contactsocialfacebook = contactFacebook;
        leadData.contactsociallinkedin = contactLinkedin;
        leadData.contactsocialinstagram = contactInstagram;
        leadData.contact_roles = contactData?.contactRoles?.map(role => role.roleName)?.join(', ');

        const contactImages = this.getContactProfileImages(contactData);
        leadData.image = contactImages?.map(role => role.name)?.join(',\n')||"";

        leadData.customAttributeValues?.filter(field=> field?.statusId==1).forEach(el => {
            let value: any = '';

            if(el.customAttribute.statusId!=3){
                switch (el.customAttribute.formControlId) {
                    case CustomFieldTypes.DROPDOWN:
                        try {
                            value = el.value ? JSON.parse(el.value)?.name : null;
                        } catch (e) {
                            value = null;
                        }
                        break;
                    case CustomFieldTypes.CHECKBOX:
                        try {
                            value = el.value ? JSON.parse(el.value)?.join(', ') : null;
                        } catch (e) {
                            value = null;
                        }
                        break;
                    case CustomFieldTypes.RADIO_BUTTON:
                        value = el.value ? el.value : null;
                        break;
                    case CustomFieldTypes.TOOGLE_BUTTON:
                        value = el.value;
                        break;
                    case CustomFieldTypes.RATING:
                        value = el.value;
                        break;
                    case CustomFieldTypes.INPUT:
                    case CustomFieldTypes.NUMBER:
                    case CustomFieldTypes.DECIMAL:
                    case CustomFieldTypes.PERCENTAGE:
                    case CustomFieldTypes.CURRENCY:
                    case CustomFieldTypes.MULTI_LINE:
                    case CustomFieldTypes.EMAIL:
                    case CustomFieldTypes.PHONE:
                    case CustomFieldTypes.URL:
                    case CustomFieldTypes.AUTONUMBER:
                    case CustomFieldTypes.FORMULA:
                    case CustomFieldTypes.ENCRYPTEDTEXT:
                    case CustomFieldTypes.TIME:
                    case CustomFieldTypes.IPADDRESS:
                    case CustomFieldTypes.RICHTEXT:
                    case CustomFieldTypes.BARCODE:
                        value = el.value;
                        break;
                    case CustomFieldTypes.USERLOOKUP:
                        value = el?.userLookupValue||'';
                        break;
                    case CustomFieldTypes.DATE_PICKER:
                        value = el.value ? this.datePipe.transform(el.value, 'MM/dd/yyyy') : '';
                        break;
                    case CustomFieldTypes.DATETIMEPICKER:
                        value = el.value ? this.timeZoneService.formateToUserDate(el.value,'MM/DD/YYYY | h:mm a',false) : '';
                        break;
                    case CustomFieldTypes.MULTISELECT:
                        const arrVal = el.value ? JSON.parse(el.value) : [];
                        if (arrVal.length) {
                            value = arrVal.map(val => val.name)?.join(', ')
                        } else {
                            value = '';
                        }
                        break;
                    default:
                        let files: any[] = [];
                        try {
                            files = (typeof el.value === 'string' && el.value.length) ? JSON.parse(el.value) : el.value;
                        } catch (error) {
                            files = [];
                        }

                        if (files?.length) {
                            value = files.filter(val => val?.name).map(val => val.name).join(',\n');
                        } else {
                            value = '';
                        }
                        break;
                }

                leadData[el.customAttribute.fieldName] = value;
            }

        });

        const { leadEmails, leadPhones } = leadData;

        leadData.work = leadEmails?.length ? leadEmails[0]?.email?.emailAddress : '';
        leadData.workphone = leadPhones?.length ? leadPhones[0]?.phone?.number : '';
        leadData.workphoneCountry = leadData.workphone ? leadPhones[0]?.phone?.country : '';
        leadData.workphoneCode = leadData.workphone ? leadPhones[0]?.phone?.code : '';

        const { leadWebsite, leadTwitter, leadFacebook, leadLinkedin, leadInstagram } =
            this.getLeadSocialProfiles(leadData);

        leadData.website = leadWebsite;
        leadData.twitter = leadTwitter;
        leadData.facebook = leadFacebook;
        leadData.linkedin = leadLinkedin;
        leadData.instagram = leadInstagram;

        leadData['address'] = (leadData['city'] ? leadData['city'] + ', ' : '')
            + (leadData['state'] ? leadData['state'] + ', ' : '')
            + (leadData['country'] ? leadData['country'] + ', ' : '')
            + (leadData['zipcode'] ? leadData['zipcode'] : '');

        // Format Account Types
        leadData.leadTypesName = this.removeCommas(leadData, 'leadTypesName');
        leadData.classificationColor = leadData?.stageColor||"";
        leadData.activeInactiveStatus = leadData?.status?.name||"";

        return leadData;
    }

    processFieldName(fieldName: string): string {
        // Removes all parentheses from field name
        fieldName = fieldName.split('(')[0];

        // Removes all dots from field name
        fieldName = fieldName.split('.')[0];

        // Removes all slashes from field name
        fieldName = fieldName.split('/')[0];

        // Removes all spaces from field name
        fieldName = fieldName.split(' ').join('');

        return fieldName;
    }

    processViewData(leadData) {
        if (!leadData) {
            return {};
        };

        const contactData = this.getContactDetails(leadData);
        const { workEmailAddress, homeEmailAddress, ce1EmailAddress, ce2EmailAddress } = this.getContactEmails(contactData);
        const { mobilePhone, homePhone, workPhone, cp1Phone, cp2Phone } = this.getContactPhones(contactData);
        const { contactWebsite, contactTwitter, contactFacebook, contactLinkedin, contactInstagram } =
            this.getContactSocialProfiles(contactData);
        const profileImages = this.getContactProfileImages(contactData);
        const businessCardImages = this.getBusinessCaardImages(contactData);
        const { leadWebsite, leadTwitter, leadFacebook, leadLinkedin, leadInstagram } =
            this.getLeadSocialProfiles(leadData);

        const { businessName, mainCustomer, status, leadTypes, leadNumber, timezoneName, currencyUnit, doingBusinessAs, taxId,
            employeesRangeName, annualRevenueName, ownershipName, stageName, foundedYear, industryName, leadEmails,
            leadPhones, sicCode, naicsCode, ownerName,leadsStatus, sequenceNumber, jobFunction,
            sourceName, ratingName, description, createdByUserName, createdDate, updatedByUserName, updatedDate, previousStage, previousStageOwner, currentStage, currentStageOwner, stageChangedBy, stageChangedDate} = leadData;

        const viewAccountData = {
            contactSequenceNumber: contactData?.sequenceNumber,
            contactSalutation: contactData?.salutation?.name,
            contactFirstName: contactData?.firstName,
            contactMiddleName: contactData?.middleName,
            contactLastName: contactData?.lastName,
            workEmailAddress,
            homeEmailAddress,
            ce1EmailAddress,
            ce2EmailAddress,
            mobilePhone,
            homePhone,
            workPhone,
            cp1Phone,
            cp2Phone,
            contactWebsite,
            contactTwitter,
            contactFacebook,
            contactLinkedin,
            contactInstagram,
            profileImages,
            businessCardImages,
            jobFunction,
            jobFunctions: contactData?.contactRoles?.map(role => role.roleName)?.join(', '),
            businessName,
            parentAccount: (typeof mainCustomer === 'string') ? mainCustomer : mainCustomer?.name,
            accountTypes: leadTypes?.map(el => el.type?.name)?.join(', '),
            leadTypes: leadTypes?.map(el => el.type?.name)?.join(', '),
            leadNumber,
            timezoneName,
            sequenceNumber,
            currency: currencyUnit ? `${currencyUnit?.name} - ${currencyUnit?.code}` : null,
            doingBusinessAs,
            taxId,
            employeesRangeName,
            annualRevenueName,
            ownershipName,
            ownerName,
            leadsStatus,
            stageName,
            foundedYear,
            industryName,
            leadEmail: leadEmails?.length ? leadEmails.find(e=> e?.email)?.email?.emailAddress : '',
            leadPhone: leadPhones?.length ? leadPhones.find(e=> e?.phone)?.phone?.number : '',
            leadPhoneCountry: leadPhones?.length ? leadPhones.find(e=> e?.phone)?.phone?.country : '',
            leadPhoneCode: leadPhones?.length ? leadPhones.find(e=> e?.phone)?.phone?.code : '',
            leadWebsite,
            leadTwitter,
            leadFacebook,
            leadLinkedin,
            leadInstagram,
            sicCode,
            naicsCode,
            sourceName,
            ratingName,
            description,
            tags: leadData?.tags,
            createdByUserName,
            createdDate,
            updatedByUserName,
            updatedDate,
            previousStage,
            previousStageOwner,
            currentStage,
            currentStageOwner,
            stageChangedBy,
            stageChangedDate,
            status
        };

        return viewAccountData;
    }

    sortContactAccordingToPrimary(leadContacts) {
        let sortedContacts = leadContacts?.length>0 ? leadContacts.sort((a, b) => b.contact.isPrimaryContact - a.contact.isPrimaryContact) : [];
        return sortedContacts || [];
    }
}
